{
  "level": "hpmv",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:hpmv",
    "objects": "AREAS.E3:hpmv.e3",
    "mesh": "TREES.E3:hpmv.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1548.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1667.0999755859375,
        630.0,
        142.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 142.0,
      "bbox_min": [
        1665.5,
        604.800048828125,
        142.0
      ],
      "bbox_max": [
        1667.0999755859375,
        605.699951171875,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        0.7761140465736389,
        0.0
      ],
      "plane_d": 628.6524047851562,
      "bbox_min": [
        1548.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1640.0,
        522.5,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1548.0,
      "bbox_min": [
        1548.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1548.0,
        480.0,
        91.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: garage",
      "entity_class": "CSlidingDoor",
      "piece_name": "garage",
      "offset": 6929,
      "centroid": [
        1525.0,
        481.875,
        90.875
      ],
      "bbox_min": [
        1502.0,
        480.0,
        80.0
      ],
      "bbox_max": [
        1548.0,
        485.0,
        98.0
      ],
      "dimensions_source": {
        "span_x": 46.0,
        "span_y": 5.0,
        "height_z": 18.0,
        "door_width": 46.0,
        "door_depth": 5.0,
        "leaf_depth": 4.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.7241,
          0.0,
          0.6897
        ]
      },
      "vertices": [
        [
          1508.6666259765625,
          480.0,
          98.0
        ],
        [
          1508.6666259765625,
          480.0,
          98.0
        ],
        [
          1541.3333740234375,
          480.0,
          98.0
        ],
        [
          1541.3333740234375,
          480.0,
          98.0
        ],
        [
          1548.0,
          480.0,
          91.0
        ],
        [
          1548.0,
          480.0,
          91.0
        ],
        [
          1548.0,
          480.0,
          80.0
        ],
        [
          1502.0,
          480.0,
          80.0
        ],
        [
          1502.0,
          480.0,
          91.0
        ],
        [
          1502.0,
          480.0,
          91.0
        ],
        [
          1541.3333740234375,
          485.0,
          98.0
        ],
        [
          1508.6666259765625,
          485.0,
          98.0
        ],
        [
          1502.0,
          485.0,
          91.0
        ],
        [
          1502.0,
          485.0,
          80.0
        ],
        [
          1548.0,
          485.0,
          80.0
        ],
        [
          1548.0,
          485.0,
          91.0
        ]
      ],
      "plane_distance": -1183.7272,
      "authentic_texture": "chkdiarrhea"
    }
  ],
  "tutorial_messages": []
}